import { pick } from "lodash"
import { MODAL_INDICATOR_CANVAS_ID } from "components/atoms/chart/logic/chartConfig"
import { checkIsSp } from "utils/util"
/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_INDICATOR_CHART_INITIALIZE =
  "REDUX_INDICATOR_CHART_INITIALIZE"
export const REDUX_INDICATOR_CHART_CHANGE_SYMBOL =
  "REDUX_INDICATOR_CHART_CHANGE_SYMBOL"
export const REDUX_INDICATOR_CHART_CHANGE_SYMBOL_SP =
  "REDUX_INDICATOR_CHART_CHANGE_SYMBOL_SP"
export const REDUX_INDICATOR_CHART_SP_MODAL = "REDUX_INDICATOR_CHART_SP_MODAL"
export const REDUX_INDICATOR_CHART_CHANGE_TYPE =
  "REDUX_INDICATOR_CHART_CHANGE_TYPE"

export const indicatorChartInitialize = (canvasId: string) => {
  return {
    type: REDUX_INDICATOR_CHART_INITIALIZE,
    data: {
      canvasId,
    },
  }
}

export const indicatorChartSymbol = (canvasId: string, symbolData: object) => {
  const data = pick(symbolData, [
    "ID",
    "TargetDate",
    "DisplayName",
    "AnnouncedAt",
    "DisplayTargetDate",
    "ActualText",
    "SurveyText",
    "RevisedPriorText",
    "CountryCode",
  ])
  return {
    type: REDUX_INDICATOR_CHART_CHANGE_SYMBOL,
    data: {
      canvasId,
      data,
    },
  }
}

export const indicatorChartChangeType = (canvasId: string, type: number) => {
  return {
    type: REDUX_INDICATOR_CHART_CHANGE_TYPE,
    data: {
      canvasId,
      data: { type: type },
    },
  }
}

export const spIndicatorChartSymbol = (symbolData: object) => {
  const data = pick(symbolData, [
    "ID",
    "TargetDate",
    "DisplayName",
    "AnnouncedAt",
    "DisplayTargetDate",
    "ActualText",
    "SurveyText",
    "RevisedPriorText",
    "CountryCode",
  ])
  return {
    type: REDUX_INDICATOR_CHART_CHANGE_SYMBOL_SP,
    data: {
      modalVisible: true,
      data,
    },
  }
}

export const spIndicatorChartModal = (modalVisible: boolean) => {
  return {
    type: REDUX_INDICATOR_CHART_SP_MODAL,
    data: {
      modalVisible,
    },
  }
}

const initialStatePropety: {
  ID: string
  TargetDate: number
  type: 0 | 1
  modalVisible?: boolean
} = {
  ID: "",
  TargetDate: null,
  type: 0,
}

export default (
  state: { [key: string]: object } = {},
  action: { type: string; data?: any }
) => {
  switch (action.type) {
    case REDUX_INDICATOR_CHART_INITIALIZE:
      const isPhone = checkIsSp()
      return {
        ...state,
        [action.data.canvasId]: !isPhone
          ? initialStatePropety
          : { ...initialStatePropety, modalVisible: false },
      }
    case REDUX_INDICATOR_CHART_CHANGE_SYMBOL:
      return {
        ...state,
        [action.data.canvasId]: {
          ...state[action.data.canvasId],
          ...action.data.data,
        },
      }
    case REDUX_INDICATOR_CHART_CHANGE_TYPE:
      return {
        ...state,
        [action.data.canvasId]: {
          ...state[action.data.canvasId],
          ...action.data.data,
        },
      }
    case REDUX_INDICATOR_CHART_CHANGE_SYMBOL_SP:
      return {
        ...state,
        [MODAL_INDICATOR_CANVAS_ID]: {
          ...state[MODAL_INDICATOR_CANVAS_ID],
          ...action.data.data,
          modalVisible: action.data.modalVisible,
        },
      }
    case REDUX_INDICATOR_CHART_SP_MODAL:
      return {
        ...state,
        [MODAL_INDICATOR_CANVAS_ID]: {
          ...state[MODAL_INDICATOR_CANVAS_ID],
          modalVisible: action.data.modalVisible,
        },
      }
    default:
      return state
  }
}
